import * as React from 'react';

const HalfStarSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} fill="none" {...props}>
        <mask id="half-star_svg__path-1-inside-1_1340_6910" fill="#fff">
            <path d="M16 5.333l4.079 6.546L28 13.482l-5.4 5.648.816 7.537L16 23.612l-7.416 3.055.816-7.537L4 13.482l7.921-1.603L16 5.333z" />
        </mask>
        <path
            d="M16 5.333l4.079 6.546L28 13.482l-5.4 5.648.816 7.537L16 23.612l-7.416 3.055.816-7.537L4 13.482l7.921-1.603L16 5.333z"
            fill="#fff"
        />
        <path
            d="M16 5.333l1.697-1.057L16 1.552l-1.697 2.724L16 5.333zm4.079 6.546l-1.697 1.058.455.731.845.171.397-1.96zM28 13.482l1.446 1.382 2.507-2.623-3.556-.72L28 13.483zm-5.4 5.648l-1.446-1.382-.643.673.1.925 1.989-.216zm.816 7.537l-.761 1.849 3.112 1.282-.362-3.347-1.989.216zM16 23.612l.762-1.85L16 21.45l-.762.314.762 1.85zm-7.416 3.055l-1.989-.216-.362 3.347 3.112-1.282-.761-1.85zM9.4 19.13l1.988.216.1-.925-.642-.673L9.4 19.13zM4 13.482l-.397-1.96-3.556.72 2.507 2.622L4 13.482zm7.921-1.603l.397 1.96.845-.17.455-.732-1.697-1.058zm2.382-5.488l4.079 6.546 3.394-2.116-4.079-6.545-3.394 2.115zm5.38 7.448l7.92 1.603.794-3.92-7.921-1.603-.794 3.92zm6.871-1.74l-5.4 5.65 2.892 2.764 5.4-5.649-2.892-2.764zm-5.942 7.247l.816 7.536 3.977-.43-.817-7.537-3.976.43zm3.566 5.471l-7.416-3.054-1.524 3.698 7.417 3.055 1.523-3.699zm-8.94-3.054l-7.416 3.054 1.523 3.699 7.417-3.054-1.524-3.7zm-4.666 5.12l.816-7.537-3.976-.431-.817 7.536 3.977.431zm.274-9.135l-5.4-5.648-2.892 2.764 5.4 5.648 2.892-2.764zm-6.45-2.306l7.922-1.603-.794-3.92-7.92 1.603.793 3.92zm9.222-2.505l4.08-6.546-3.395-2.115-4.08 6.545 3.395 2.116z"
            fill="#D1410C"
            mask="url(#half-star_svg__path-1-inside-1_1340_6910)"
        />
        <path
            d="M8.584 26.667L16 23.612V5.333l-4.079 6.546-7.92 1.603 5.4 5.648-.817 7.537z"
            fill="#D1410C"
        />
    </svg>
);

HalfStarSvg.displayName = 'HalfStarSvg';
export default HalfStarSvg;
